import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { authApi } from '@/api'

export interface UserInfo {
  id: string
  email: string
  nickname: string
  avatar: string
  role: 'admin' | 'user'
  joinDate?: string
}

export const useUserStore = defineStore(
  'user',
  () => {
    const userInfo = ref<UserInfo | null>(null)
    const accessToken = ref('')
    const refreshToken = ref('')

    const isLoggedIn = computed(() => !!accessToken.value)
    const isAdmin = computed(() => userInfo.value?.role === 'admin')

    async function login(email: string, password: string) {
      const res = await authApi.login({ email, password })
      const { data } = res.data
      accessToken.value = data.accessToken
      refreshToken.value = data.refreshToken
      userInfo.value = data.user
      // 同步写入 localStorage 供 request 拦截器读取
      localStorage.setItem('access_token', data.accessToken)
      localStorage.setItem('refresh_token', data.refreshToken)
    }

    async function logout() {
      try { await authApi.logout() } catch { /* 静默 */ }
      accessToken.value = ''
      refreshToken.value = ''
      userInfo.value = null
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
    }

    function setTokens(access: string, refresh: string) {
      accessToken.value = access
      refreshToken.value = refresh
      localStorage.setItem('access_token', access)
      localStorage.setItem('refresh_token', refresh)
    }

    return { userInfo, accessToken, refreshToken, isLoggedIn, isAdmin, login, logout, setTokens }
  },
  {
    persist: {
      key: 'portal-user',
      pick: ['userInfo', 'accessToken', 'refreshToken'],
    },
  },
)
